export const DELETE_STORE_AGENTS_ERROR = 'DELETE_STORE_AGENTS_ERROR';
export const DELETE_STORE_AGENTS_SUCCESS =
  'DELETE_STORE_AGENTS_SUCCESS';
export const DELETE_STORE_AGENTS_START = 'DELETE_STORE_AGENTS_START';
